import React, { Component } from "react";
import PropTypes from "prop-types";
import Banner from "../../components/Banner";
import JobsList from "./JobsList";
import jobsStyle from "../../assets/jss/jobsListStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import Footer from "../../components/Footer";
import { getJobCategories, getEntities } from './getFilterData';
import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class Jobs extends Component {

  constructor(props) {
    super(props);
    this.goToDetails = this.goToDetails.bind(this);
    this.state = {
      jobs: [],
      keywords: '',
      category: '',
      entity: '',
      jobCategories: null,
      entities: null
    };
    this.handleFilters = this.handleFilters.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  handleFilters(keywords = '', category = '', entity = '') {
    if (category === "All Job Categories") category = ''
    if (entity === "All Entities") entity = ''
    this.setState({ keywords, category, entity })
  }

  componentDidMount = async () => {
    getJobCategories().then(data => {
      this.setState({ jobCategories: data.message.categories })
    });

    getEntities().then(data => {
      this.setState({ entities: data.message.entities })
    });
  }

  render() {

    return (
      <div>
        <div style={{ minHeight: "calc(100vh - 92px)" }}>
          <Banner onClick={this.handleFilters} jobCategories={this.state.jobCategories} entities={this.state.entities} />
          <JobsList goToDetails={this.goToDetails} keywords={this.state.keywords} category={this.state.category} entity={this.state.entity} />
        </div>
        <Footer />
      </div>
    );
  }

  goToDetails(values) {

    this.props.history.push({
      pathname: `jobs/${values}`
    });
  }
}

Jobs.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(jobsStyle)(Jobs);
